(() => {
  let cartDrawer = document.querySelector("[data-cart-drawer]");
  const cartCount = document.querySelector("[data-cart-count]");
  const menuToggle = document.querySelector("[data-menu-toggle]");
  const nav = document.querySelector("[data-site-nav]");

  function openCart() {
    cartDrawer = document.querySelector("[data-cart-drawer]");
    if (!cartDrawer) return;
    cartDrawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
    if (nav) nav.classList.remove("is-open");
    syncMenuExpanded();
  }

  function closeCart() {
    cartDrawer = document.querySelector("[data-cart-drawer]");
    if (!cartDrawer) return;
    cartDrawer.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  function bindCartDrawer() {
    cartDrawer = document.querySelector("[data-cart-drawer]");
    if (!cartDrawer) return;
    cartDrawer.querySelectorAll("[data-close-cart]").forEach((el) => {
      el.addEventListener("click", (event) => {
        event.preventDefault();
        closeCart();
      });
    });
  }

  function updateCount(count) {
    if (cartCount) cartCount.textContent = String(count);
  }

  function syncMenuExpanded() {
    if (!menuToggle || !nav) return;
    menuToggle.setAttribute("aria-expanded", nav.classList.contains("is-open") ? "true" : "false");
  }

  async function refreshCartDrawer() {
    const root = window.Shopify?.routes?.root || "/";
    const response = await fetch(`${root}cart?section_id=cart-drawer`);
    if (!response.ok) throw new Error("Could not refresh cart");
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const next = doc.querySelector("[data-cart-drawer]");
    const current = document.querySelector("[data-cart-drawer]");
    if (next && current) {
      current.replaceWith(next);
      bindCartDrawer();
    }
  }

  async function addItems(items) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    });
    if (!response.ok) throw new Error("Could not add to cart");
    const cart = await fetch("/cart.js").then((res) => res.json());
    updateCount(cart.item_count);
    await refreshCartDrawer();
    openCart();
  }

  document.querySelectorAll("[data-open-cart]").forEach((el) => {
    el.addEventListener("click", (event) => {
      event.preventDefault();
      openCart();
    });
  });

  bindCartDrawer();

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    const drawer = document.querySelector("[data-cart-drawer]");
    if (drawer?.classList.contains("is-open")) closeCart();
    if (nav?.classList.contains("is-open")) {
      nav.classList.remove("is-open");
      syncMenuExpanded();
    }
  });

  if (menuToggle && nav) {
    menuToggle.setAttribute("aria-expanded", "false");
    menuToggle.addEventListener("click", () => {
      nav.classList.toggle("is-open");
      syncMenuExpanded();
    });
  }

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const id = Number(data.get("id"));
      const quantity = Number(data.get("quantity") || 1);
      try {
        await addItems([{ id, quantity }]);
      } catch {
        form.submit();
      }
    });
  });

  document.querySelectorAll("[data-add-pair]").forEach((button) => {
    button.addEventListener("click", async () => {
      const first = Number(button.dataset.variantId);
      const pair = Number(button.dataset.pairVariantId);
      if (!first || !pair) return;
      try {
        await addItems([
          { id: first, quantity: 1 },
          { id: pair, quantity: 1 },
        ]);
      } catch {
        window.location.href = `/cart/${pair}:1,${first}:1`;
      }
    });
  });

  document.querySelectorAll("[data-qty]").forEach((wrap) => {
    const input = wrap.querySelector("input");
    wrap.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", () => {
        const delta = Number(button.dataset.qtyDelta);
        const next = Math.max(1, Number(input.value || 1) + delta);
        input.value = String(next);
      });
    });
  });
})();
